module.exports = __webpack_public_path__ + "static/computer_with_graphs-cdb7c6aef67399009285d22476f14b2d.svg";